const CommunityDevelopmentProjects = [
  {
    id: "project-1",
    title: "Gunita ng Pasko: Litrato para sa pamilyang katutubo",
    thumbnail: "/project-1/p1-7.jpg",
    contentPath: "/project-content/GunitaNgPasko.md",
    description: "A holiday initiative dedicated to celebrating and preserving the heritage of our indigenous communities.",
    division: "community-development",
    IsFeatured: false,
    images: [
      {
        path: "project-1/p1-1.jpg",
        aspect: "16/9"
      },
      {
        path: "project-1/p1-2.jpg",
        aspect: "16/9"
      },
      {
        path: "project-1/p1-3.jpg",
        aspect: "16/9"
      },
      {
        path: "project-1/p1-5.png",
        aspect: "16/9"
      },
      {
        path: "project-1/p1-6.jpg",
        aspect: "16/9"
      }
    ]
  },
  {
    id:  "project-2",
    title: "Patak ng Kalinisan: Empowering the aeta community through hygiene",
    thumbnail: "project-2/p2-1.jpg",
    contentPath: "/project-content/PatakNgKalinisan.md",
    description: "A health and wellness initiative that aims to uplift indigenous Aeta communities by promoting sustainable sanitation practices.",
    division: "community-development",
    IsFeatured: true,
    images: [
      {
        path: "project-2/p2-2.jpg",
        aspect: "9/16"
      },
      {
        path: "project-2/p2-3.jpg",
        aspect: "16/9"
      },
      {
        path: "project-2/p2-4a.jpg?",
        aspect: "9/16"
      },
      {
        path: "project-2/p2-5.jpg",
        aspect: "9/16"
      },
      {
        path: "project-2/p2-6.jpg",
        aspect: "16/9"
      },
      {
        path: "project-2/p2-7.png",
        aspect: "9/16"
      }
    ]
  },
]

export default CommunityDevelopmentProjects;